/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::322a83b8b3adf4368a1a41af2e0d0e23>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Printer".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/printer
 * Usage guidance:
 * Multi purpose - Known uses: print page, print-friendly view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const PrinterIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "PrinterIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 .75A.75.75 0 0 1 3.75 0h8.5a.75.75 0 0 1 .75.75V4h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1v2.25a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75V13H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1zM4.5 4h7V1.5h-7zM3 11.5v-1.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 .75.75v1.25h1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5zM11 7h2v1.5h-2zm-6.5 4v3.5h7V11z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
PrinterIcon.displayName = 'PrinterIcon';
var _default = exports.default = PrinterIcon;